import {
  Box,
  FormControlLabel,
  FormHelperText,
  Grid,
  InputLabel,
  Radio,
  RadioGroup,
  TextField,
  Typography,
} from "@mui/material";
import useStyles from "./confirmationStyle";
import dayjs from "dayjs";
import { useSelector } from "react-redux";
import { useEffect, useRef, useState } from "react";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";

interface DateConfirmationProps {
  error: any;
  formData?: any;
  setFormData: (data: any) => void;
  isDisabled?: any;
  isDoorToDoorAccept: any;
  isFullPackAccept: any;
  setAnyChangeFieldValue?: any;
}

const DateConfirmation = ({
  error,
  formData,
  setFormData,
  isDisabled,
  isDoorToDoorAccept,
  isFullPackAccept,
  setAnyChangeFieldValue,
}: DateConfirmationProps) => {
  const classes = useStyles();

  const { userProfile } = useSelector((state: any) => state?.user);
  const fieldRefs = useRef<Record<string, HTMLInputElement | null>>({});
  const [isTesterSection, setIsTesterSection] = useState(true);

  useEffect(() => {
    setIsTesterSection(
      userProfile?.features?.includes("Basic Work Diary") || false
    ); // Sync profile changes
  }, [userProfile]);

  const handleDateChange = (
    serviceName: string,
    field: "startDate" | "startTime",
    value: string | null
  ) => {
    const updatedServices = formData.services.map((service: any) =>
      service.name === serviceName
        ? {
            ...service,
            [field]: value,
          }
        : service
    );
    setFormData({
      ...formData,
      services: updatedServices,
    });
    setAnyChangeFieldValue(true);
  };

  const handleStatusChange = (serviceName: string, value: string) => {
    const updatedServices = formData.services.map((service: any) =>
      service.name === serviceName
        ? {
            ...service,
            jobStatus: value, // status is mapped to jobStatus
          }
        : service
    );
    setFormData({
      ...formData,
      services: updatedServices,
    });
    setAnyChangeFieldValue(true);
  };

  const renderDateSection = (
    label: string,
    service: any,
    isCheck: any,
    index: number
  ) => (
    <Grid
      key={index}
      item
      xs={12}
      sm={12}
      sx={{
        paddingLeft: "10px !important",
        paddingTop: "4px !important",
        paddingBottom: "2px !important",
        display: "flex",
        alignItems: "center",
        borderTop: "2px solid #CFCFCF",
        background: "#FFF",
        minHeight: "100px !important",
      }}
    >
      <Box sx={{ display: "block" }}>
        <InputLabel
          sx={{ color: "#333333", fontWeight: 600, fontSize: "18px" }}
          shrink
        >
          {label}
          <span style={{ color: "red", fontWeight: 500 }}>*</span>
        </InputLabel>
        <LocalizationProvider dateAdapter={AdapterDayjs}>
          <DatePicker
            label=""
            value={
              service?.startDate && dayjs(service?.startDate).isValid()
                ? dayjs(service?.startDate)
                : null
            }
            format={
              userProfile?.dateFormat ? userProfile?.dateFormat : "DD/MM/YYYY"
            }
            // onChange={(e: any) =>
            //   handleDateChange(service.name, "startDate", e.target.value)
            // }
            onChange={(newValue: any) => {
              handleDateChange(
                service.name,
                "startDate",
                newValue ? dayjs(newValue).toISOString() : ""
              );
            }}
            disabled={isCheck}
            slotProps={{
              textField: {
                size: "small",
                placeholder: `${
                  userProfile?.dateFormat
                    ? userProfile?.dateFormat
                    : "DD/MM/YYYY"
                }`,

                variant: "outlined",
                error: !!error?.services?.[service.name]?.startDate,
                helperText: error?.services?.[service.name]?.startDate || "",
                sx: {
                  height: "36px",
                  // padding: "10px 4px",
                  // width: "20px",
                  marginRight: "6px",
                  marginBottom: "6px !important",
                  marginTop: "0px !important",
                },
                InputProps: {
                  sx: {
                    height: "36px",
                    width: "164px",
                  },
                },
              },
            }}
            minDate={
              service.name === "Removal" || service.name === "Full Pack"
                ? dayjs()
                : undefined
            }
            maxDate={
              service.name === "Full Pack" &&
              formData?.services?.find((s: any) => s.name === "Removal")
                ?.startDate
                ? dayjs(
                    formData?.services?.find((s: any) => s.name === "Removal")
                      ?.startDate
                  )
                : undefined
            }
          />
        </LocalizationProvider>
      </Box>
      <Box sx={{ display: "flex", flexDirection: "column" }}>
      <TextField
        // inputRef={(el: any) => {
        //             fieldRefs.current[field.id] = el;
        //           }}
        name="startTime"
        type="time"
        variant="outlined"
        disabled={isCheck}
        sx={{ marginRight: "8px", marginTop: "20px !important" }}
        value={service?.startTime ? service?.startTime : ""}
        InputProps={{
          sx: { height: "36px", padding: "10px 4px", width: "120px" },
        }}
        onChange={(e) =>
          handleDateChange(service.name, "startTime", e.target.value)
        }
        error={!!error?.services?.[service.name]?.startTime}
        // helperText={error?.services?.[service.name]?.startTime || ""}
        // FormHelperTextProps={{
        //   sx: {
        //     marginTop: "2px", // space above helper text
        //     paddingLeft: "4px", // padding from left (align with input)
        //     fontSize: "12px", // optional: smaller font
        //     marginLeft: "2px", // align with input
        //     marginRight: "0px", // align with input
        //   },
        // }}
      />
       {error?.services?.[service.name]?.startTime && (
    <FormHelperText
      sx={{
        color: "#d32f2f",       // make error red
        marginTop: "2px",
        paddingLeft: "4px",
        fontSize: "12px",
        marginLeft: "2px",
      }}
    >
      {error.services[service.name].startTime}
    </FormHelperText>
  )}
      </Box>
      <RadioGroup
        row
        value={service.jobStatus || ""}
        onChange={(e) => handleStatusChange(service.name, e.target.value)}
        sx={{ display: "contents" }}
      >
        {["fixed", "provisional", "awaiting"].map((status) => (
          <FormControlLabel
            key={status}
            value={status}
            disabled={isDisabled || isCheck}
            sx={{
              fontSize: "12px",
              marginTop: "20px",
              ".MuiTypography-root": {
                fontSize: "12px",
              },
            }}
            control={
              <Radio
                size="small"
                sx={{
                  color: error?.services?.[service.name]?.jobStatus
                    ? "red"
                    : "",
                  transform: "scale(0.8)",
                  "& .MuiSvgIcon-root": { fontSize: 18 },
                }}
              />
            }
            label={status.charAt(0).toUpperCase() + status.slice(1)}
          />
        ))}
      </RadioGroup>
    </Grid>
  );

  return (
    <>
      <Grid container spacing={2} rowGap={0} rowSpacing={0}>
        <Grid
          item
          xs={12}
          md={12}
          sx={{ padding: "16px 6px 6px 6px !important" }}
        >
          <Typography sx={{ fontWeight: 600, color: "#0F906E" }}>
            Services Date
          </Typography>
        </Grid>
        {(isTesterSection
          ? formData?.services?.filter(
              (service: any) =>
                service.name === "Removal" || service.name === "Full Pack"
            )
          : formData?.services
        )?.map((service: any, index: number) =>
          renderDateSection(
            service.name === "Removal"
              ? "Moving On"
              : service.name === "Full Pack"
              ? "Packing Start"
              : `${service.name} Date`,
            service,
            service.status === "accept" ? false : true,
            index
          )
        )}
        {/* {renderDateSection("Moving On", "movingDate", isDoorToDoorAccept)}
      {renderDateSection("Packing Start", "packingDate", isFullPackAccept)} */}
      </Grid>
    </>
  );
};

export default DateConfirmation;
